import React, { useState, useEffect } from "react";
import "./PopupQuestion.css";
import question from "../imagesHome/help.png";
import conti from "../imagesHome/conti.png";
import coinImg from "../header/images/coin.png";

const PopupQuestion = ({ quizExplanation, coinCount = 0, onRevealAnswer }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showExplanation, setShowExplanation] = useState(false);
  const [explanationPurchased, setExplanationPurchased] = useState(false);
  const [answerRevealed, setAnswerRevealed] = useState(false);
  const [unlockingExplanation, setUnlockingExplanation] = useState(false);
  const [unlockingAnswer, setUnlockingAnswer] = useState(false);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
    setShowExplanation(explanationPurchased);
    // Nu mai resetăm instant stările interne aici!
  };
  // Resetăm stările interne DOAR după ce popup-ul a dispărut complet (isVisible devine false)
  useEffect(() => {
    if (!isVisible) {
      setAnswerRevealed(false);
      setUnlockingExplanation(false);
      setUnlockingAnswer(false);
    }
  }, [isVisible]);

  const handleShowExplanation = () => {
    if (coinCount < 20) {
      setUnlockingExplanation("insufficient");
    } else {
      setUnlockingExplanation(true);
    }
  };

  const handleExplanationUnlock = () => {
    setUnlockingExplanation(false);
    setExplanationPurchased(true);
    setShowExplanation(true);
  };

  const handleOpenAnswerPurchase = () => {
    if (coinCount < 30) {
      setUnlockingAnswer("insufficient");
    } else {
      setUnlockingAnswer(true);
    }
  };

  const handleConfirmAnswer = () => {
    setAnswerRevealed(true);
    setShowExplanation(true);
    setUnlockingAnswer(false);
    onRevealAnswer?.();
    closePopup();
  };

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="popup-question-container">
      <button
        type="button"
        className="oriented-question-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide ajutor"
      >
        <img src={question} className="question-popup-icon" alt="Ajutor" />
      </button>

      {isVisible && (
        <>
          <div className={`popup-question-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
          <div
            className={`popup-question ${isOpen ? "open" : ""}`}
            role="dialog"
            aria-modal="true"
            aria-label="Ajutor pentru lectie"
          >
            <button
              className={`popup-question-close ${unlockingExplanation || unlockingAnswer ? "popup-question-close--text" : ""}`.trim()}
              onClick={unlockingExplanation || unlockingAnswer ? () => {
                setUnlockingExplanation(false);
                setUnlockingAnswer(false);
              } : closePopup}
            >
              {unlockingExplanation || unlockingAnswer ? "Inapoi" : "×"}
            </button>
            <div className="popup-question-content">
              {unlockingAnswer === "insufficient" ? (
                <>
                  <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>
                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      <p>Nu ai suficiente monede pentru a cumpara raspunsul.</p>
                    </div>
                  </div>
                  <div className="popup-question-btns" style={{marginTop: 16}}>
                    <button
                      className="popup-question-btn popup-question-btn--ack"
                      onClick={closePopup}
                    >
                      <span className="popup-question-btn-label">Am inteles</span>
                    </button>
                  </div>
                </>
              ) : unlockingAnswer ? (
                <>
                  <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>

                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      <p>
                        Raspunsul costa <strong>30 monede</strong>. Doresti sa il cumperi?
                      </p>
                    </div>
                  </div>

                  <div className="popup-question-btns">
                    <button
                      className="popup-question-btn popup-question-btn--answer"
                      onClick={handleConfirmAnswer}
                    >
                      <span className="popup-question-btn-label">Cumpara</span>
                    </button>
                  </div>
                </>
              ) : unlockingExplanation === "insufficient" ? (
                <>
                  <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>
                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      <p>Nu ai suficiente monede pentru a cumpara explicatia.</p>
                    </div>
                  </div>
                  <div className="popup-question-btns" style={{marginTop: 16}}>
                    <button
                      className="popup-question-btn popup-question-btn--ack"
                      onClick={closePopup}
                    >
                      <span className="popup-question-btn-label">Am inteles</span>
                    </button>
                  </div>
                </>
              ) : unlockingExplanation ? (
                <>
                  <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>

                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      <p>
                        Explicatia costa <strong>20 monede</strong>. Doresti sa o cumperi?
                      </p>
                    </div>
                  </div>

                  <div className="popup-question-btns">
                    <button
                      className="popup-question-btn popup-question-btn--answer"
                      onClick={handleExplanationUnlock}
                    >
                      <span className="popup-question-btn-label">Cumpara</span>
                    </button>
                  </div>
                </>
              ) : (
                <>

                 <div className="popup-question-coins-info">
                    <img src={coinImg} className="popup-coin-icon" alt="coins" />
                    <span>Sold: {coinCount}</span>
                  </div>

                  <div className="popup-question-mascot">
                    <img src={conti} className="popup-question-conti" alt="Conti" />
                    <div className="popup-question-bubble">
                      {showExplanation ? (
                        <div
                          className="popup-question-explanation-content"
                          dangerouslySetInnerHTML={{
                            __html: quizExplanation || "<p>Explicatia nu este disponibila pentru acest quiz.</p>"
                          }}
                        />
                      ) : (
                        <p>Ai ramas blocat?</p>
                      )}
                    </div>
                  </div>
                 
                  <div className="popup-question-btns">
                    {!answerRevealed && !showExplanation && (
                      <>
                        <button
                          className="popup-question-btn popup-question-btn--hint"
                          onClick={handleShowExplanation}
                        >
                          <span className="popup-question-btn-label">Vezi explicatia</span>
                        </button>
                        <div style={{textAlign: "center", margin: "4px 0", color: "#919191", fontWeight: 600}}>sau</div>
                        <button
                          className="popup-question-btn popup-question-btn--answer"
                          onClick={handleOpenAnswerPurchase}
                        >
                          <span className="popup-question-btn-label">Vezi raspunsul</span>
                        </button>
                      </>
                    )}
                    {!answerRevealed && showExplanation && (
                      <>
                        <button
                          className="popup-question-subtle-answer-btn"
                          onClick={handleOpenAnswerPurchase}
                        >
                          Nu este suficient de clar? Poti cumpara raspunsul
                         
                        </button>
                        <button
                          className="popup-question-btn popup-question-btn--ack"
                          onClick={closePopup}
                        >
                          <span className="popup-question-btn-label">Am inteles</span>
                        </button>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupQuestion;
